import { faqs } from '@/mocks/articles';

export function getHomeSchema() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '草榴二维码指南',
        url: 'https://caoliu-qrcode.example.com',
        description: '致力于为草榴社区用户提供最新、最全的入口指南',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@caoliu-qrcode.example.com',
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '草榴二维码 - 最新入口获取与使用指南',
        url: 'https://caoliu-qrcode.example.com',
        description: '草榴二维码是进入草榴社区的重要通道，提供最新草榴二维码获取方式、扫码步骤详解、安全使用建议及常见问题解答',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        name: '首页',
        url: 'https://caoliu-qrcode.example.com',
        isPartOf: { '@id': 'https://caoliu-qrcode.example.com/#website' },
        about: { '@id': 'https://caoliu-qrcode.example.com/#organization' },
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqs.slice(0, 6).map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };
}